"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEXT_CATALOGUE = exports.MOBILE_CATALOGUE = exports.LINK = exports.DESKTOP_CATALOGUE = exports.CTA_TEXT = exports.CATALOGUES_SEE_ALL_LINK = exports.CATALOGUES_SEE_ALL = void 0;
const DESKTOP_CATALOGUE = exports.DESKTOP_CATALOGUE = 'desktop-catalogue';
const MOBILE_CATALOGUE = exports.MOBILE_CATALOGUE = 'mobile-catalogue';
const NEXT_CATALOGUE = exports.NEXT_CATALOGUE = 'next-catalogue';
const CATALOGUES_SEE_ALL = exports.CATALOGUES_SEE_ALL = 'catalogues-see-all';
const CATALOGUES_SEE_ALL_LINK = exports.CATALOGUES_SEE_ALL_LINK = 'catalogues-see-all-link';
const LINK = exports.LINK = 'link';
const CTA_TEXT = exports.CTA_TEXT = 'cta-text';